<p-breadcrumb
  [model]="[{ label: 'Taxas', routerLink: ['/tax-rates'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Taxas</h5>
      <p>Gerencie as taxas por país e estado</p>
    </div>
    <p-button label="Nova Taxa" routerLink="/tax-rates/create" rounded />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="taxRates()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5">
      <div class="w-100">
        <label for="countryFilter">País</label>
        <input
          pInputText
          type="text"
          id="countryFilter"
          class="block"
          [(ngModel)]="countryFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Filtrar por país"
          fluid
        />
      </div>

      <div class="w-100">
        <label for="stateFilter">Estado</label>
        <input
          pInputText
          type="text"
          id="stateFilter"
          class="block"
          [(ngModel)]="stateFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Filtrar por estado"
          fluid
        />
      </div>

      <div class="w-100">
        <label for="cityFilter">Cidade</label>
        <input
          pInputText
          type="text"
          id="cityFilter"
          class="block"
          [(ngModel)]="cityFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Filtrar por cidade"
          fluid
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th pSortableColumn="country">
        País
        <p-sortIcon field="country" />
      </th>

      <th pSortableColumn="state">
        Estado
        <p-sortIcon field="state" />
      </th>

      <th pSortableColumn="city">
        Cidade
        <p-sortIcon field="city" />
      </th>

      <th pSortableColumn="rate" class="text-right">
        Taxa
        <p-sortIcon field="rate" />
      </th>

      <th class="text-right">Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.country }}</td>
      <td>{{ getStateLabel(item.state) }}</td>
      <td>{{ item.city }}</td>
      <td class="text-right">{{ item.rate | number:'1.2-2' }}%</td>
      <td class="text-right">
        <p-button
          icon="ph ph-pencil"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/tax-rates/update/' + item.id"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
